import {Component, Input} from '@angular/core';
import {NbActionsModule, NbButtonModule, NbIconModule, NbToggleModule, NbTooltipModule} from '@nebular/theme';
import {ListComponent} from '../list.component';
import {BaseComponent} from 'compob2b-libs'
import {Columns} from 'compob2b-table'
import {RouterLink} from '@angular/router'
import {DatePipe, NgForOf, NgIf} from '@angular/common'
import {BaseModule} from '../../../../../../../compob2b-table/lib/components/base/base.module'

@Component({
  selector: 'app-list-columns',
  imports: [
    NbActionsModule,
    NbTooltipModule,
    RouterLink,
    NbIconModule,
    NbButtonModule,
    NgIf,
    NgForOf,
    BaseModule,
    DatePipe,
    NbToggleModule
  ],
  templateUrl: './list-columns.component.html',
})
export class ListColumnsComponent extends BaseComponent {
  @Input() list: ListComponent<any>;

  @Input() row;
  @Input() colIndex: number;
  @Input() rowIndex: number;
  @Input() column: Columns;
}
